/**
 * Created by eliranm on 05/10/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var Page = require('ui.components/page/Page');
    var Config = require('content-config/contentImportErrorsConfig.json');
    var ContentImportErrorsLayoutModel = require('content-models/ContentImportErrorsLayoutModel');
    var ContentImportErrorsLayout = require('content-views/content-import-errors/ContentImportErrorsLayout');
    var ContentImportErrorsTableView = require('content-views/content-import-errors/ContentImportErrorsTableView');
    var OrganizeCollectionDecorator = require('decorators/organizeCollectionDecorator/OrganizeCollectionDecorator');
    var ContentImportErrorsModel = require('content-models/ContentImportErrorsModel');
    var ContentImportErrorsCollection = require('content-collections/ContentImportErrorsCollection');
    var ContentImportErrorsGridModel = require('content-models/ContentImportErrorsGridModel');
    var ContentImportErrorsComparators = require('content-comparators/ContentImportErrorsComparators');

    var ContentImportErrorsController = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportErrorsController = Marionette.Controller.extend({

            // overridden

            initialize: function () {

                this.channel = LEContent.media.channel(Config.media.channel);
                this.vent = this.channel.vent;

                this._initModels();
                this._initCollections();
                this._initViews();
                this._bindEvents();
            },

            onClose: function () {
                this.contentImportErrorsLayout.close();
            },


            // public

            getMainView: function () {
                return this.contentImportErrorsPage;
            },

            showImportContentErrors: function () {
                LEContent.logger.info('showing import content errors', 'ContentImportErrorsController:showImportContentErrors');
                // don't allow accessing this page if no import-errors data was found (i.e. if not navigated after unsuccessful import)
                if (!LEContent.context.get(LEContent.context.KEYS.contentImportErrorsResponse)) {
                    LEContent.logger.info('navigation to content import errors page is not allowed. navigating away...', 'ContentImportErrorsController:showImportContentErrors');
                    _.defer(LE.router.navigateBack);
                    return;
                }
                this.errorsCollectionRawData = LEContent.context.getAndRemove(LEContent.context.KEYS.contentImportErrorsResponse);
                this._createAndShowErrorsTable();
            },


            // private

            _initModels: function () {
                this.contentImportErrorsLayoutModel = new ContentImportErrorsLayoutModel();
                this.contentImportErrorsGridModel = new ContentImportErrorsGridModel();
            },

            _initCollections: function () {
                this.contentImportErrorsCollection = new ContentImportErrorsCollection();
            },

            _initViews: function () {

                this.contentImportErrorsTableView = null;

                this.contentImportErrorsLayout = new ContentImportErrorsLayout({
                    vent: this.vent,
                    model: this.contentImportErrorsLayoutModel
                });

                this.contentImportErrorsPage = new Page({
                    moduleName:LEContent.moduleName,
                    context:LE.context,
                    view: this.contentImportErrorsLayout,
                    header: this.contentImportErrorsLayoutModel.getHeader()
                });

                this.listenTo(this.contentImportErrorsPage, 'close', this._onContentImportErrorsPageClose);
            },

            _bindEvents: function () {
                this.listenTo(this.vent, Config.events.closePageDelegate, this._navigateBack);
                this.listenTo(this.vent, Config.events.errorsTablePageChange, this._onErrorsTablePageChange, this);
            },

            _decorateCollection: function () {
                this.organizeCollectionDecorator = OrganizeCollectionDecorator.decorate(this.contentImportErrorsCollection, {
                    pageSize: Config.errorsTablePageSize,
                    lazy: true,
                    comparator: ContentImportErrorsModel.KEYS.rowIndex // sort by this key when calling organize()
                });
                this.listenTo(this.organizeCollectionDecorator, 'reset', this._onOrganizeCollectionReset, this);
            },

            _createAndShowErrorsTable: function () {
                this._decorateCollection();
                this.contentImportErrorsCollection.reset(this.errorsCollectionRawData, {parse: true});
                this.organizeCollectionDecorator.organize();

                this.contentImportErrorsTableView = new ContentImportErrorsTableView({
                    vent: this.vent,
                    model: this.contentImportErrorsGridModel,
                    collection: this.organizeCollectionDecorator,
                    comparators: ContentImportErrorsComparators
                });
                this.contentImportErrorsLayout.errorsTableRegion.show(this.contentImportErrorsTableView);
            },

            _onOrganizeCollectionReset: function () {
                this.contentImportErrorsLayout.setPagingInfo(this.organizeCollectionDecorator.getPagerInfo());
            },

            _onErrorsTablePageChange: function (currentPageNumber) {
                this.organizeCollectionDecorator.organize({currentPage: currentPageNumber});
            },

            _onContentImportErrorsPageClose: function () {
                this._reconstruct();
            },

            _destruct: function () {
                if (this.contentImportErrorsTableView) {
                    this.contentImportErrorsTableView.close();
                }
                this.contentImportErrorsLayout.close();
                this.contentImportErrorsPage.close();
            },

            _reconstruct: function () {
                this._destruct();
                this._initViews();
            },

            _navigateBack: function () {
                LEContent.router.navigateNonBackable(Config.routes.import);
            }

        });

    });

    return ContentImportErrorsController;
});
